import { debateFights } from "@/mocks/hotTopics";

export default function DebateZone() {
  return (
    <section id="fights" className="bg-background-100/50">
      <div className="mx-auto w-full max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
              争议焦点 · 两派观点
            </p>
            <h4 className="flex items-center gap-3 font-serif text-2xl font-black text-foreground-950 md:text-3xl">
              <a href="#fights" className="flex items-center gap-3">
                正在吵起来的焦点
              </a>
            </h4>
          </div>
          <p className="max-w-xs text-sm leading-relaxed text-foreground-500">
            一个焦点，正反两个阵营。看两边各有多少人、各自在坚持什么。
          </p>
        </div>

        <div className="flex flex-col gap-5">
          {debateFights.map((f) => (
            <article
              key={f.title}
              className="rounded-xl border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <div className="flex flex-col gap-3 border-b border-background-200 pb-4 md:flex-row md:items-start md:justify-between">
                <div className="min-w-0">
                  <h5 className="font-serif text-lg font-black text-foreground-950 md:text-xl">
                    {f.title}
                  </h5>
                  <p className="mt-1.5 max-w-3xl text-sm leading-relaxed text-foreground-500">
                    {f.context}
                  </p>
                </div>
                <span className="flex shrink-0 items-center gap-2 self-start rounded-full border border-accent-300 bg-accent-50 px-3 py-1 text-xs font-medium text-accent-800">
                  <i className="ri-arrow-left-right-line text-sm" />
                  {f.note}
                </span>
              </div>

              <div className="mt-5 grid grid-cols-1 gap-4 lg:grid-cols-2">
                {/* 支持方 */}
                <div className="rounded-lg border border-primary-200 bg-primary-50/60 p-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <span className="flex h-6 w-6 items-center justify-center rounded-md bg-primary-500 text-xs text-background-50">
                        <i className="ri-thumb-up-line" />
                      </span>
                      <span className="text-sm font-semibold text-foreground-900">{f.positive.label}</span>
                    </div>
                    <span className="font-serif text-xl font-black text-primary-600">{f.positive.pct}%</span>
                  </div>
                  <div className="mt-3 h-1.5 overflow-hidden rounded-full bg-background-200">
                    <div className="h-full rounded-full bg-primary-500" style={{ width: `${f.positive.pct}%` }} />
                  </div>
                  <ul className="mt-4 flex flex-col gap-2">
                    {f.positive.points.map((pt) => (
                      <li key={pt} className="flex items-start gap-2 text-xs leading-relaxed text-foreground-700">
                        <i className="ri-checkbox-circle-line mt-0.5 text-sm text-primary-500" />
                        {pt}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* 反对方 */}
                <div className="rounded-lg border border-secondary-200 bg-secondary-50/60 p-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <span className="flex h-6 w-6 items-center justify-center rounded-md bg-secondary-500 text-xs text-background-50">
                        <i className="ri-thumb-down-line" />
                      </span>
                      <span className="text-sm font-semibold text-foreground-900">{f.negative.label}</span>
                    </div>
                    <span className="font-serif text-xl font-black text-secondary-600">{f.negative.pct}%</span>
                  </div>
                  <div className="mt-3 h-1.5 overflow-hidden rounded-full bg-background-200">
                    <div className="h-full rounded-full bg-secondary-500" style={{ width: `${f.negative.pct}%` }} />
                  </div>
                  <ul className="mt-4 flex flex-col gap-2">
                    {f.negative.points.map((pt) => (
                      <li key={pt} className="flex items-start gap-2 text-xs leading-relaxed text-foreground-700">
                        <i className="ri-checkbox-circle-line mt-0.5 text-sm text-secondary-600" />
                        {pt}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}